<template>
  <div class="distributionSetting">
      <el-form :model="form" ref="form" label-width="180px" style="margin:50px auto;width:80%">
        <el-form-item label="分销">
            <el-radio-group v-model="form.resource" @change="changeresource" style="float:left;margin-left:15px;margin-top:5px">
                <el-radio :label="6">关闭</el-radio>
                <el-radio :label="3">开启</el-radio>
            </el-radio-group>
        </el-form-item>
        <div v-if="form.resource != 6">
            <el-form-item v-for="(item,index) in this.form.commission" :key="index" :label="item.id+'级：'">
                <el-input v-model="item.commission" style="width:80%;text-align:left">
                    <template slot="append">%</template>
                </el-input><br>
                <div style="text-align:left;margin-left:10%;font-size:5px">{{item.id}}级分佣比例</div>
            </el-form-item>
        </div>
        <el-form-item label="分销商介绍" style="margin:15px auto">
            <vue-ueditor-wrap v-model="form.content" :config="myConfig"></vue-ueditor-wrap>
        </el-form-item>
      </el-form>
      <div style="margin-bottom:10px">
          <el-button type="primary" @click="submit" size="small">提交</el-button>
      </div>
  </div>
</template>

<script>
import {getdistributionList, distributionSetting} from '../../service/distribution'
import qs from 'qs'
import VueUeditorWrap from 'vue-ueditor-wrap'
export default {
    name: 'distributionSetting',
    components: { VueUeditorWrap  },
    data() {
      return {
        form:{
            resource:"6",
            commission:[{id:"",commission:""}]
        },
        myConfig: {
            // 编辑器不自动被内容撑高
            autoHeightEnabled: false,
            // 初始容器高度
            initialFrameHeight: 400,
            // 初始容器宽度
            initialFrameWidth: '80%',
            // 上传文件接口（这个地址是我为了方便各位体验文件上传功能搭建的临时接口，请勿在生产环境使用！！！）
            //serverUrl: 'http://35.201.165.105:8000/controller.php',
            serverUrl: 'https://api.goodyiyao.cn/index.php/api/File_logic/upload?action=config&action=uploadimage&encode=utf-8&path_type=distribution',
            // UEditor 资源文件的存放路径，如果你使用的是 vue-cli 生成的项目，通常不需要设置该选项，vue-ueditor-wrap 会自动处理常见的情况，如果需要特殊配置，参考下方的常见问题2
            UEDITOR_HOME_URL: '/ue/'
        },
      }
    },
    created(){
        getdistributionList().then(res=>{
            this.form.commission=[]
            this.form.resource = res.leve.id
            this.form.content = res.leve.content
            res.list.forEach(item=>{
                this.form.commission.push({id:item.id,commission:item.commission})
            })
        })
    },
    methods:{
        changeresource(){
            this.form.commission = []
            if(parseInt(this.form.resource)!=6){
                for(let i=0; i<parseInt(this.form.resource); i++){
                    this.form.commission.push({id:i+1,commission:""})
                }
            }
        },
        submit(){
            let data = {
                distribution_level:this.form.resource,
                commission:this.form.commission,
                content:this.form.content
            }
            distributionSetting(data).then(()=>{
                this.$message.success('保存成功')
            })
        }
    }
  }
</script>

<style lang="scss" scoped>
.el-radio{
    font-size: 24px;
}
.distributionSetting{
    height: 100%;
    width: 100%;
    background-color:#fff;
    font-size:24px;
}
</style>